module.exports = __webpack_public_path__ + "static/media/villager_0.c23fd417.png";